// removed by extract-text-webpack-plugin
module.exports = {"content":"video__content-tBzgE blocks__content--MOaB","title":"video__title-3q_DX","videoContainer":"video__videoContainer-5Tyl3"};


//////////////////
// WEBPACK FOOTER
// ./components/video/video.css
// module id = 854
// module chunks = 0